import React from 'react';
import { motion } from 'framer-motion'
import { fadeIn } from '../variants';


const Work = () => {
  return (
    <></>
    // <section className='mt-11' id='work'>
    //   <div className='container mx-auto'>
    //     <div className='flex flex-col lg:flex-row gap-x-10'>
    //       <div className='flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0'>
    //         {/* text */}
    //         <div>
    //           <h2 className='h2 leading-tight text-accent'>My Latest <br/>
    //           Work.
    //           </h2>
    //           <p className='max-w-sm mb-16'>Lorem dfgkldfg gdfgeirt4 werwer uiuyi ncbvxncb zxvxv wrwer etrt
    //             rtrrytrututuutr tuuuuuuuuufg eruasfjashf!
    //           </p>
    //           <button className='btn btn-sm'>View all projects</button>
    //         </div>
    //         {/* image 1 */}
    //         <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
    //           {/* overlay */}
    //           <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
    //           {/* img */}
    //           <motion.img 
    //             className='group-hover:scale-125 translate-all duration-500' 
    //             src={Img1} 
    //             alt='Project 1' 
    //             initial='hidden'
    //             animate='visible'
    //             variants={fadeIn}
    //           />
    //           {/* pretitle */}
    //           <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
    //             <span className='text-gradient'>Web3 developer</span>
    //           </div>
    //           {/* title */}
    //           <div className='absolute -bottom-full left-12 group-hover:bottom-11 transition-all duration-500 z-50'>
    //             <span>Project Title 1</span>
    //           </div>
    //         </div>
    //       </div>
    //       <div className='flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0'>
    //         {/* image 2 */}
    //         <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
    //           {/* overlay */}
    //           <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
    //           {/* img */}
    //           <motion.img 
    //             className='group-hover:scale-125 translate-all duration-500' 
    //             src={Img2} 
    //             alt='Project 2' 
    //             initial='hidden'
    //             animate='visible'
    //             variants={fadeIn}
    //           />
    //           {/* pretitle */}
    //           <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
    //             <span className='text-gradient'>UI/UX Designer</span>
    //           </div>
    //           {/* title */}
    //           <div className='absolute -bottom-full left-12 group-hover:bottom-11 transition-all duration-500 z-50'>
    //             <span>Project Title 2</span>
    //           </div>
    //         </div>
    //       </div>
    //       <div className='flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0'>
    //         {/* image 3 */}
    //         <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
    //           {/* overlay */}
    //           <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
    //           {/* img */}
    //           <motion.img 
    //             className='group-hover:scale-125 translate-all duration-500' 
    //             src={Img3} 
    //             alt='Project 3' 
    //             initial='hidden'
    //             animate='visible'
    //             variants={fadeIn}
    //           />
    //           {/* pretitle */}
    //           <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
    //             <span className='text-gradient'>Frontend Developer</span>
    //           </div>
    //           {/* title */}
    //           <div className='absolute -bottom-full left-12 group-hover:bottom-11 transition-all duration-500 z-50'>
    //             <span>Project Title 3</span>
    //           </div>
    //         </div>
    //       </div>

          
    //     </div>
        
    //   </div>
    // </section>
  );
};

export default Work;
